var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcEmptyContent',{staticClass:"content-not-found",attrs:{"name":_vm.notFoundString,"description":_vm.t('collectives', 'Select a page from the list or create a new one.')},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('PageIcon')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }